import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MobileMenuPopup = ({
  anchorName,
  menuItems,
  menuOpen,
  id,
  setCurrentOpenPopup,
  setMenuScreenOpen,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="cursor-pointer text-inherit font-inherit flex opacity-[75%] hover:text-[#CDCBFF] transition-colors hover:opacity-[100%]"
        aria-haspopup="true"
        aria-expanded="true"
        onClick={() => {
          if (menuOpen) setCurrentOpenPopup(null);
          else setCurrentOpenPopup(id);
        }}>
        <div
          className={`text-inherit font0inherit ${
            menuOpen && "text-blue-600"
          }`}>
          {anchorName}
        </div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={`w-6 h-6 ml-2 transition-all duration-300	${
            menuOpen && "rotate-180"
          }`}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>

      {menuOpen && (
        <div
          className="animate-expandDown flex flex-col items-center w-full py-2 gap-4 bg-gray-100"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu">
          {menuItems.map((item, index) => (
            <div
              onClick={() => {
                setMenuScreenOpen(false);
                navigate(item.path);
              }}
              key={index}
              className="cursor-pointer hover:text-blue-600 text-center">
              {item.name}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MobileMenuPopup;
